import React from "react";
import { useDispatch } from "react-redux";
import { Button } from "antd";
import { LeftOutlined, ClockCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  displayScheduleDateFullNameFormat,
  epochToNormalDate,
} from "../../utils/utility";
import schedulesActions from "../../redux/schedules/actions";
import { t } from "i18next";

const BuyTicketHeaderTwoWay = () => {
  const dispatch = useDispatch();
  const { setOpenChooseTwoWayScheduleModal } = schedulesActions;
  const { schedules, schedulesId, schedulesTwoWay, schedulesTwoWayId } =
    useSelector((state) => state.schedulesReducer);
  const { selectedLanguage } = useSelector((state) => state.mainReducer);

  const { cities } = useSelector((state) => state.citiesReducer);

  const getSchedule = schedules?.find(
    (schedule) => schedule?.kursId === schedulesId
  );

  const getScheduleTwoWay = schedulesTwoWay?.find(
    (schedule) => schedule?.kursId === schedulesTwoWayId
  );

  const getCityId = (type) => {
    return schedules?.find((schedule) => schedule?.kursId === schedulesId)?.[
      type
    ];
  };

  const findCityName = (scheduleId) => {
    const name = selectedLanguage === "bg" ? "name" : "nameLat";
    return cities?.find((city) => city?.id === scheduleId)?.[name];
  };

  const displayScheduleTime = (schedule) => {
    return epochToNormalDate(schedule)?.replace(/\d{2}\/\d{2}\/\d{2}/, "");
  };

  const openChooseTwoWayModal = () => {
    dispatch(setOpenChooseTwoWayScheduleModal(true));
  };

  return (
    <>
      <div
        className="buy-ticket-header-container"
        style={{ borderRadius: "0", paddingBottom: "0" }}
      >
        <div
          style={{
            width: "150px",
            background: "#fff",
            zIndex: "2",
            borderRadius: "5px",
            padding: "5px",
          }}
        >
          <div className="buy-ticket-header-item buy-ticket-header-item-bg">
            <p
              style={{ color: "#000", border: "none", fontSize: "17px" }}
              className="buy-ticket-header-text remove-pointer-events"
            >
              {t("departure")}
            </p>
          </div>
        </div>
        <div className="buy-ticket-header-item buy-ticket-header-item-bg">
          <p className="buy-ticket-header-text remove-pointer-events">{`${findCityName(
            getCityId("fromCity")
          )} - ${findCityName(getCityId("toCity"))}`}</p>
        </div>
        <div className="buy-ticket-header-item buy-ticket-header-item-bg">
          <p className="buy-ticket-header-text remove-pointer-events">
            {t("departure")} {displayScheduleTime(getSchedule?.scheduleStart)}
          </p>
        </div>

        <div className="buy-ticket-header-item buy-ticket-header-item-bg">
          <p className="buy-ticket-header-text remove-pointer-events">
            {t("sector")} {getSchedule?.sector}
          </p>
        </div>
        <div className="buy-ticket-header-item buy-ticket-header-item-bg">
          <p className="buy-ticket-header-text remove-pointer-events">
            {displayScheduleDateFullNameFormat(getSchedule?.scheduleStart)}
          </p>
        </div>
        <div
          className="buy-ticket-header-item buy-ticket-header-back-button"
          style={{ width: "280px" }}
        ></div>
      </div>

      <div
        className="buy-ticket-header-container"
        style={{ paddingTop: "10px" }}
      >
        <div
          style={{
            width: "150px",
            background: "#fff",
            zIndex: "2",
            borderRadius: "5px",
            padding: "5px",
          }}
        >
          <div className="buy-ticket-header-item buy-ticket-header-item-bg">
            <p
              style={{ color: "#000", border: "none", fontSize: "17px" }}
              className="buy-ticket-header-text remove-pointer-events"
            >
              {t("return")}
            </p>
          </div>
        </div>
        <div className="buy-ticket-header-item buy-ticket-header-item-bg">
          <p className="buy-ticket-header-text remove-pointer-events">{`${findCityName(
            getCityId("toCity")
          )} - ${findCityName(getCityId("fromCity"))}`}</p>
        </div>
        <div className="buy-ticket-header-item buy-ticket-header-item-bg">
          <p className="buy-ticket-header-text remove-pointer-events">
            {t("departure")}{" "}
            {getScheduleTwoWay &&
              displayScheduleTime(getScheduleTwoWay?.scheduleStart)}
          </p>
        </div>
        <div className="buy-ticket-header-item buy-ticket-header-item-bg">
          <p className="buy-ticket-header-text remove-pointer-events">
            {t("sector")} {getScheduleTwoWay?.sector}
          </p>
        </div>
        <div className="buy-ticket-header-item buy-ticket-header-item-bg">
          <p className="buy-ticket-header-text remove-pointer-events">
            {getScheduleTwoWay &&
              displayScheduleDateFullNameFormat(
                getScheduleTwoWay?.scheduleStart
              )}
          </p>
        </div>
        <div style={{ display: "flex", gap: "15px" }}>
          <div className="buy-ticket-header-item buy-ticket-header-back-button">
            <Button
              style={{ width: "170px" }}
              onClick={openChooseTwoWayModal}
              size="large"
              icon={<ClockCircleOutlined />}
            >
              {t("returnTime")}
            </Button>
          </div>
          <div className="buy-ticket-header-item buy-ticket-header-back-button">
            <Link to="/schedules">
              <Button
                className="custom-button "
                type="primary"
                size="large"
                icon={<LeftOutlined />}
              >
                <span className="remove-pointer-events">{t("back")}</span>
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default BuyTicketHeaderTwoWay;
